import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";


// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class StackedColumnChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
        var categoryCount = (this.props.data || []).length;
        var graphs = [];
        var valueAxes = [];
        var l =1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        var pos = "left";
        this.props.y_axis.map(function (pl, index) {
            if(l>1) { pos = "right"; }
            graphs.push({
                "id":"v"+l,
                "balloonText": "[[title]]: [[value]]",
                //"balloonText": "[[title]], [[category]]<br><span style='font-size:14px;'><b>[[value]]</b> ([[percents]]%)</span>",
                "fillAlphas": 0.9,
                "fontSize": 11,
                "labelText": "[[percents]]%",
                //"lineAlpha": 0.5,
                "title": pl,
                "type": "column",
                "valueField": pl,

            });

            l++;
        })
        const config = {
            "type": "serial",
            // Relative width so columns shrink to fit the card instead of overlapping
            "columnWidth": 0.7,
            "theme": "none",
            "legend": {
                "autoMargins": false,
                "position": "bottom",
                "borderAlpha": 0,
                "equalWidths": false,
                "horizontalGap": 10,
                "markerSize": 10,
                "useGraphSettings": true,
                "valueAlign": "left",
                "valueWidth": 0,
                "fontSize":8,
            },
            "dataProvider": this.props.data,
            "synchronizeGrid": true,
            "valueAxes": [{
                "stackType": "regular",
                "axisAlpha": 0.3,
                "gridAlpha": 0
            }],
            "graphs":graphs,
            "marginTop": 30,
            "marginRight": 0,
            "marginLeft": 90,
            "marginBottom": 40,
            "autoMargins": false,
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                "gridPosition": "start",
                //"position": "start",
                "minorGridEnabled": false,
                "axisAlpha": 1,
                "gridAlpha": 0,
                // Label every category (e.g. every date) instead of amCharts' auto-skipped subset
                "autoGridCount": false,
                "gridCount": categoryCount,
                "labelRotation": categoryCount > 12 ? 90 : 25,
                "fontSize":8,
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            }

        };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: "250px" }} options={config} />
            </div>
        );
    }
}

export default StackedColumnChart;